exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vux-circle{position:relative;width:100%;height:100%}.vux-circle-content{width:100%;text-align:center;position:absolute;left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}", ""]);

// exports
